module.exports = __webpack_public_path__ + "img/sweden-eye-and-ear-diseases-male.45e47a13.png";